module.exports = __webpack_public_path__ + "img/faro-room-4.fc1c8335.jpg";